import type { CatalogStatus } from '../types/models.js'

const DOT_CLASS: Record<CatalogStatus, string> = {
  ACTIVE: 'status-dot status-dot--active',
  SUSPENDED: 'status-dot status-dot--suspended',
  ARCHIVED: 'status-dot status-dot--archived',
}

export default function StatusDot({ status, label }: { status: CatalogStatus; label: string }) {
  return <span className={DOT_CLASS[status]} role="img" aria-label={label} title={label} />
}
